import {Injectable, Injector} from '@angular/core';
import {Observable} from 'rxjs';


import {BaseService} from '../base/base.service';
import {City} from '../../models/lookups/city';
import {Query} from '../../models/query/query';
import {WebMethodResult} from '../../models/web-method-result';
import {AppModulePath} from '../../models/app-module-path';
import {HttpClient} from '@angular/common/http';
import {PlatformLocation} from '@angular/common';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class CityService extends BaseService {
  private listUrl = '/api/cities/list';
  private saveUrl = '/api/cities/save';
  private deleteUrl = '/api/cities/delete/';

  constructor(protected injector: Injector,
              protected http2: HttpClient,
              protected platformLocation: PlatformLocation) {
    super(injector, http2, platformLocation);
  }

  list(qry: Query): Observable<City[]> {
    const url = this.listUrl + '?q=' + encodeURIComponent(JSON.stringify(qry));
    return this.get<City[]>(url, AppModulePath.CITY).pipe(
      map(res => res.map(obj => new City(obj))),
      catchError(this.handleError));
  }

  save(city: City): Observable<City> {
    return this.post<City>(this.saveUrl, AppModulePath.CITY, city).pipe(
      map(res => new City(res)),
      catchError(this.handleError));
  }

  delete(id: number): Observable<WebMethodResult> {
    return this._delete<WebMethodResult>(this.deleteUrl + id, AppModulePath.CITY).pipe(
      map(res => new WebMethodResult(res)),
      catchError(this.handleError));
  }
}
